<template>
  <div v-if="expert">
    <div class="topbar">
      <div class="brand" @click="$router.back()">&#8249; 专家详情</div>
      <button class="share-btn" @click="sharePage">分享</button>
    </div>
    <div class="content">
      <div class="card">
        <div class="expert">
          <img class="avatar-lg" v-if="expert.photo" :src="expert.photo" />
          <div class="avatar-lg" v-else>{{ expert.avatar }}</div>
          <div class="meta">
            <div class="name">{{ expert.name }}</div>
            <div class="title">{{ expert.title }}</div>
          </div>
        </div>
        <div class="muted" style="margin-top: 10px; font-size: 13px">
          {{ expert.field }}
        </div>
        <div class="detail-section rich-content" style="margin-top: 10px" v-html="sanitizeRichText(expert.bio)"></div>
      </div>
      <div class="section-title">可预约号源</div>
      <div v-if="!slots.length" class="empty">该顾问暂无可预约号源</div>
      <div
        v-for="s in sortedSlots"
        :key="s.id"
        class="card tap"
        @click="chooseSlot(s)"
        v-track="'NRCU005|NRCU005-002|专家详情页点击号源'"
      >
        <div class="row">
          <div>
            <div style="font-weight: 600">{{ s.title }}</div>
            <div class="muted">
              {{ directionNameOf(s.directionId) }} ·
              {{ s.slotType === 1 ? "报告交付" : s.durationText + " 分钟 · 电话咨询" }}
            </div>
          </div>
          <div class="price">¥{{ (s.price / 100).toLocaleString("zh-CN") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expertDetail, slotList, directionList } from "@/api/nrc.js";
import { requireLogin } from "@/utils/requireLogin.js";
import { sanitizeRichText } from "@/utils/richText.js";
import { captureReferralVisit, orderReferralToken, shareReferralPage } from "@/utils/referral.js";

export default {
  name: "ExpertDetail",
  data() {
    return {
      expert: null,
      slots: [],
      directions: [],
    };
  },
  computed: {
    // 按号源类型分组显示，跟方向详情页那边保持一致的排序逻辑
    sortedSlots() {
      return [...this.slots].sort((a, b) => a.slotType - b.slotType);
    },
  },
  created() {
    let id = this.$route.params.id;
    captureReferralVisit(1, id, this.$route.query.ref);
    expertDetail(id).then((r) => {
      this.expert = r;
    });
    slotList({ expertId: id }).then((r) => {
      this.slots = r;
    });
    directionList().then((r) => {
      this.directions = r;
    });
  },
  methods: {
    sanitizeRichText,
    // 号源卡片上显示"这是哪个门诊方向的"，直接从已经请求过的方向列表里查，不用额外发请求
    directionNameOf(directionId) {
      let direction = this.directions.find((d) => d.id === directionId);
      return direction ? direction.name : "";
    },
    chooseSlot(s) {
      requireLogin(() => {
        this.$router.push({
          path: "/order/create",
          query: {
            slotId: s.id,
            title: s.title,
            price: s.price,
            slotType: s.slotType,
            durationText: s.durationText,
            description: s.description,
            expertName: this.expert.name,
            directionId: s.directionId,
            expertId: s.expertId,
            referralVisitToken: orderReferralToken(s.expertId, s.directionId),
          },
        });
      });
    },
    sharePage() {
      requireLogin(() => shareReferralPage(`/expert/${this.expert.id}`, `推荐专家：${this.expert.name}`));
    },
  },
};
</script>

<style scoped>.share-btn{margin-left:auto;border:0;background:transparent;color:#0e7490;font-size:14px}</style>
